import { azureFunctionsURL, socketsURL, userPoolId, userPoolWebClientId } from "./environment";


const CognitoConfig = {
    userPool: {
        UserPoolId: userPoolId,
        ClientId: userPoolWebClientId
    },
};

const appConfig = {
    apiURL: azureFunctionsURL,
    socketURL: socketsURL
}


export {
    CognitoConfig,
    appConfig,
}